import {
  CheckCircleIcon,
  DotsCircleHorizontalIcon,
} from "@heroicons/react/24/solid";

const SaveButton = ({
  buttonText = "Save",
  type = "button",
  onClick,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={type}
      className={`${
        disabled && "opacity-25"
      } hover:scale-90 transition duration-500 flex px-3 items-center shadow-md text-xs font-semibold text-white justify-center gap-x-2 rounded-full  bg-senary  py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70 ${className}`}
    >
      {/* {disabled ? (
        <DotsCircleHorizontalIcon
          className="animate-spin h-5 w-5 text-white"
          viewBox="0 0 24 24"
        />
      ) : ( */}
      <CheckCircleIcon className="h-4 w-4" />
      {/* )} */}
      <div> {buttonText}</div>
    </button>
  );
};
export default SaveButton;
